import { render, staticRenderFns } from "./DiscountFilter.vue?vue&type=template&id=19f02e82"
import script from "./DiscountFilter.vue?vue&type=script&lang=js"
export * from "./DiscountFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports